import React, { useContext } from 'react';
import { ConfirmModal } from '@mummssoftware/common-ui';
import Menu from '@material-ui/core/Menu';
import { VisitContext } from '../Context/contexts/VisitContext';
import { SET_HOPE_VISIT_WARNING } from '../Context/constants';
import defaults from '../../translations/en.json';

export const HopeVisitWarningModal = () => {
  const { hopeVisitWarning, dispatchVisit } = useContext(VisitContext);

  const onOKClick = async () => {
    dispatchVisit({ type: SET_HOPE_VISIT_WARNING, payload: false });
  };

  return (
    <Menu anchorEl={hopeVisitWarning} open={hopeVisitWarning} autoFocus>
      <ConfirmModal
        onOKClick={onOKClick}
        okText={defaults.ok}
        modalText={defaults.hopeVisit}
        content={defaults.hopeVisitWarning}
      />
    </Menu>
  );
};
